import React, {useEffect , useState } from "react";
import { Message } from 'primereact/message';
export const ExpiredLink = () => {
  const [counter, setCounter] = useState(5);
  useEffect(() => {
    if(counter > 0){
      setTimeout(()=>setCounter(counter - 1), 1000);
  }
    setTimeout(() => {
      window.location.href = `https://gexonline.gexpertise.fr`;
    }, 5000);
  },[counter])
  const content=(
    <div className="ml-2">ERREUR | Ce lien a expiré. Vous allez être redirigé vers notre site. {counter} ... </div>
  )

  return (
    <div style ={{ height:'100vh'}}>
    <Message severity="error" className="border-primary w-full justify-content-center" content={content}   />
    </div>

  );
};
